// Redux Messages module
// see https://github.com/erikras/ducks-modular-redux

import { mergeUserPrefsPatch } from '../../services/kronosPrefs/userPrefs';
import { readInitialKUserSettingsForReducer } from '../../services/kronosPrefs/kUserSettingsPersist';

const LOAD_USER_SETTINGS         = 'kronos/userSettings/LOAD_USER_SETTINGS';
const DISMISS_HELP               = 'kronos/userSettings/DISMISS_HELP';
const UNDISMISS_HELP             = 'kronos/userSettings/UNDISMISS_HELP';
const RESET_DISMISSED_HELPS      = 'kronos/userSettings/RESET_DISMISSED_HELPS';
const ENABLE_DARK_THEME          = 'kronos/userSettings/ENABLE_DARK_THEME';
const DISABLE_DARK_THEME         = 'kronos/userSettings/DISABLE_DARK_THEME';
const USE_SMALL_DRAGGABLE_CARDS  = 'kronos/userSettings/USE_SMALL_DRAGGABLE_CARDS';
const SET_ACTIVE_TAB             = 'kronos/userSettings/SET_ACTIVE_TAB';
const SET_PLANNING_ASSIGNED_USER = 'kronos/userSettings/SET_PLANNING_ASSIGNED_USER';

const initialState = {
    KUserSettings: readInitialKUserSettingsForReducer(),
}

// Reducer
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_USER_SETTINGS:
            return {
                ...state,
                KUserSettings: action.KUserSettings
            };
        case DISMISS_HELP:
            return {
                ...state,
                KUserSettings: {
                    ...state.KUserSettings,
                    dismissedHelps: {
                        ...(state.KUserSettings.dismissedHelps || {}),
                        [action.helpId]: true,
                    },
                },
            };
        case UNDISMISS_HELP: {
            const next = { ...(state.KUserSettings.dismissedHelps || {}) };
            delete next[action.helpId];
            return {
                ...state,
                KUserSettings: {
                    ...state.KUserSettings,
                    dismissedHelps: next,
                },
            };
        }
        case RESET_DISMISSED_HELPS:
            return {
                ...state,
                KUserSettings: {
                    ...state.KUserSettings,
                    dismissedHelps: {},
                },
            };
        case ENABLE_DARK_THEME:
            return {
                ...state,
                KUserSettings: {
                    ...state.KUserSettings,
                    darkTheme: true
                }
            };
        case DISABLE_DARK_THEME:
            return {
                ...state,
                KUserSettings: {
                    ...state.KUserSettings,
                    darkTheme: false
                }
            };
        case USE_SMALL_DRAGGABLE_CARDS:
            return {
                ...state,
                KUserSettings: {
                    ...state.KUserSettings,
                    smallDraggableCards: !!action.smallDraggableCards
                }
            };
        case SET_ACTIVE_TAB:
            return {
                ...state,
                KUserSettings: {
                    ...state.KUserSettings,
                    tabs: {
                        ...state.KUserSettings.tabs,
                        [action.screen]: action.tab
                    }
                }
            };
        case SET_PLANNING_ASSIGNED_USER:
            return {
                ...state,
                KUserSettings: {
                    ...state.KUserSettings,
                    planning: {
                        ...(state.KUserSettings.planning || {}),
                        assigned: action.assigned
                    }
                }
            };
        default:
            return state;
    }
};

// Actions
function loadUserSettings(settings) { return { type: LOAD_USER_SETTINGS, settings: settings } }
export function onLoadUserSettings(settings) {
    return (dispatch) => {
        dispatch(loadUserSettings(settings));
    }
}

function _dismissHelp(helpId) { return { type: DISMISS_HELP, helpId } }
export function dismissHelp(helpId) {
    return (dispatch) => {
        if (!helpId) {
            return;
        }
        dispatch(_dismissHelp(helpId));
    }
}

function _undismissHelp(helpId) { return { type: UNDISMISS_HELP, helpId } }
export function undismissHelp(helpId) {
    return (dispatch) => {
        if (!helpId) {
            return;
        }
        dispatch(_undismissHelp(helpId));
    }
}

function _resetDismissedHelps() { return { type: RESET_DISMISSED_HELPS } }
export function resetDismissedHelps() {
    return (dispatch) => {
        dispatch(_resetDismissedHelps());
    }
}

function enableDarkTheme() { return { type: ENABLE_DARK_THEME } }
export function showDarkTheme() {
    return (dispatch) => {
        dispatch(enableDarkTheme());
    }
}

function disableDarkTheme() { return { type: DISABLE_DARK_THEME } }
export function hideDarkTheme() {
    return (dispatch) => {
        dispatch(disableDarkTheme());
    }
}

function _setSmallDraggableCards(smallDraggableCards) { return { type: USE_SMALL_DRAGGABLE_CARDS, smallDraggableCards } }
export function setSmallDraggableCards(smallDraggableCards) {
    return (dispatch) => {
        dispatch(_setSmallDraggableCards(smallDraggableCards));
    }
}

function _setActiveTab(screen, tab) { return { type: SET_ACTIVE_TAB, screen, tab } }
export function setActiveTab(screen, tab) {
    return (dispatch) => {
        dispatch(_setActiveTab(screen, tab));
    }
}

function _setPlanningAssignedUser(assigned) { return { type: SET_PLANNING_ASSIGNED_USER, assigned } }
export function setPlanningAssignedUser(assigned) {
    return (dispatch) => {
        dispatch(_setPlanningAssignedUser(assigned));
    }
}

export function storeUserSettings(settings) {
    return (_dispatch, getState) => {
        try {
            const uid = getState().auth?.user?.id;
            const userId = uid != null ? String(uid) : null;
            if (userId) {
                mergeUserPrefsPatch(userId, { kUserSettings: settings });
                if (typeof window !== 'undefined' && window.localStorage) {
                    window.localStorage.removeItem('KUserSettings');
                }
            } else if (typeof window !== 'undefined' && window.localStorage) {
                window.localStorage.setItem('KUserSettings', JSON.stringify(settings));
            }
        } catch (_e) {
            /* ignore quota / private mode */
        }
    };
}
